// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1Emmp","selected":"Chip_selected__319Qa"};